import type { SupportedLocale } from '../i18n';

const RTL_REFERENCE_LOCALES = new Set<SupportedLocale>(['ar', 'he']);

/**
 * Customer-facing order reference. Keep this aligned across admin and
 * storefront so WhatsApp support messages match what shoppers see.
 */
export function formatPublicOrderReference(orderId: string): string {
  return `#${orderId.slice(-8).toUpperCase()}`;
}

export function isolateOrderReferenceForLocale(reference: string, locale: SupportedLocale): string {
  if (!RTL_REFERENCE_LOCALES.has(locale)) return reference;

  // FSI/PDI keeps a Latin reference stable when embedded in Arabic/Hebrew text.
  return `\u2068${reference}\u2069`;
}
